"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PausedNeighbors = void 0;
class PausedNeighbors {
    pausedNeighbors;
    constructor() {
        this.pausedNeighbors = new Map();
    }
    add(node, msgChainId) {
        if (!this.pausedNeighbors.has(msgChainId)) {
            this.pausedNeighbors.set(msgChainId, new Set());
        }
        this.pausedNeighbors.get(msgChainId).add(node);
    }
    delete(node, msgChainId) {
        this.pausedNeighbors.get(msgChainId)?.delete(node);
        if (this.pausedNeighbors.get(msgChainId)?.size === 0) {
            this.pausedNeighbors.delete(msgChainId);
        }
    }
    deleteAll(node) {
        this.pausedNeighbors.forEach((neighbors, msgChainId) => {
            neighbors.delete(node);
            if (neighbors.size === 0) {
                this.pausedNeighbors.delete(msgChainId);
            }
        });
    }
    isPaused(node, msgChainId) {
        if (!this.pausedNeighbors.has(msgChainId)) {
            return false;
        }
        return this.pausedNeighbors.get(msgChainId).has(node);
    }
}
exports.PausedNeighbors = PausedNeighbors;
//# sourceMappingURL=PausedNeighbors.js.map